
import React, { useState, useRef, useCallback, useMemo } from 'react'
import { useTranslate, useListContext, useRecordContext, useLocaleState, PaginationActions, useListPaginationContext } from 'react-admin'
import { MenuItem, Box, Select, Button, Checkbox, ListItemText, Dialog, DialogContent, Slide, TablePagination } from '@mui/material'
import { useTheme } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers'
import dayjs from 'dayjs'
import 'dayjs/locale/fr';
import 'dayjs/locale/en';
import 'dayjs/locale/es';
import { ExportDataButton } from '../../ui/button/ExportDataButton';


const customStyles = ({ theme }) => ({
    container: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        backgroundColor: theme.palette.background.paper,
        borderRadius: "12px",
        padding: "10px !important",
        marginBottom: "20px",
    },
    itemGrid: { display: 'flex', alignItems: 'center', justifyContent: 'center', width: "80%", },
})

const FiltersIcon = ({ color }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-filter">
            <path stroke="none" d="M0 0h16v16H0z" fill="none" strokeWidth="0.6666666666666666" />
            <path d="M2.667 2.667h10.667v1.448a1.333 1.333 0 0 1 -0.391 0.943L10 8v4.667l-4 1.333v-5.667L3.013 5.048A1.333 1.333 0 0 1 2.667 4.151z" />
        </svg>
    )
}

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


const FiltersDialog = (
    { open,
        setOpen,
        searchOption,
        setSearchOption,
        startDate,
        setStartDate,
        endDate,
        ignorePagination,
        setEndDate,
        perPage,
        handleChangeSearchOption,
        sensorsToShowNames,
        handleSensorToShowChange,
        isAllSensorsSelected,
        sensorsNames,
        setAllListsFilters,
        setAllListsPerPage
    }
) => {

    const theme = useTheme();
    const styles = customStyles({ theme });
    const contentBg = theme.palette.mode === 'light' ? theme.palette.background.paper : theme.palette.background.default;
    const translate = useTranslate()
    const [locale, setLocale] = useLocaleState();
    const [openSelectDisplayedMeasures, setOpenSelectDisplayedMeasures] = useState(false);
    const dialogRef = useRef(null);
    const handleDrag = (event) => {
        const dialogElement = dialogRef.current;
        if (!dialogElement) return;

        // Detect touch or mouse events
        const startY = event.type === 'mousedown'
            ? event.clientY
            : event.touches[0].clientY;

        const onMove = (moveEvent) => {
            const currentY = moveEvent.type === 'mousemove'
                ? moveEvent.clientY
                : moveEvent.touches[0].clientY;

            const deltaY = currentY - startY;

            if (deltaY > 150) {
                // Close the dialog if dragged down more than 150px
                handleClose();
            } else {
                // Temporarily move the dialog down
                dialogElement.style.transform = `translateY(${Math.min(deltaY, 150)}px)`;
            }
        };

        const onEnd = () => {
            // Reset dialog position and remove listeners
            dialogElement.style.transform = '';
            window.removeEventListener('mousemove', onMove);
            window.removeEventListener('mouseup', onEnd);
            window.removeEventListener('touchmove', onMove);
            window.removeEventListener('touchend', onEnd);
        };

        // Add listeners for dragging and release
        window.addEventListener('mousemove', onMove);
        window.addEventListener('mouseup', onEnd);
        window.addEventListener('touchmove', onMove);
        window.addEventListener('touchend', onEnd);
    };


    const handleCloseSelectDisplayedMeasures = () => {
        setOpenSelectDisplayedMeasures(false);
    };

    const handleOpenSelectDisplayedMeasures = () => {
        setOpenSelectDisplayedMeasures(true);
    };


    return (
        <Dialog
            ref={dialogRef}
            open={open}
            TransitionComponent={Transition}
            onClose={() => { }}
            fullScreen
            PaperProps={{
                style: { boxShadow: 'none' }, // Optional: Remove shadow around the dialog
            }}
            slotProps={{
                backdrop: { style: { backgroundColor: 'transparent' } }
            }}
            sx={{
                "& .MuiPaper-root": {
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    width: "100%",
                    height: "auto",
                    minHeight: "20%",
                    maxHeight: "70%",
                    margin: "0px",
                    padding: "0px",
                    border: 1,
                    borderTopColor: theme.palette.text.disabled,
                    borderWidth: "1px",
                    borderRadius: "12px 12px 0px 0px"
                }
            }}
        >

            <Box
                sx={{
                    width: "100%",
                    height: "15px",
                    margin: "0px",
                    padding: "10px 0px 10px 0px",
                    borderRadius: "0px",
                    backgroundColor: "none",
                    opacity: 0.45,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
                onMouseDown={handleDrag} // Handle mouse drag
                onTouchStart={handleDrag}

            >
                <Box
                    sx={{
                        width: "40px",
                        height: "4px",
                        margin: "1px",
                        borderRadius: "12px",
                        backgroundColor: theme.palette.text.secondary,
                        opacity: 0.45
                    }}


                >
                </Box>
            </Box>
            <DialogContent
                sx={{
                    margin: "0px",
                    padding: "16px 16px 30px 16px",
                    background: contentBg,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-end',
                    alignItems: 'center'
                }}>

                <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    label={translate("resources.measures.displayedMeasures")}
                    multiple
                    value={sensorsToShowNames}
                    onChange={handleSensorToShowChange}
                    open={openSelectDisplayedMeasures}
                    onClose={handleCloseSelectDisplayedMeasures}
                    onOpen={handleOpenSelectDisplayedMeasures}
                    renderValue={() => translate("resources.measures.displayedMeasures")}
                    MenuProps={{
                        PaperProps: {
                            style: {
                                maxHeight: "250px",
                            },
                        },
                    }}
                    sx={{
                        width: "100%",
                        height: "48px",
                        margin: "0px 0px 0px 0px !important",
                        "& .MuiInputBase-root": {
                            padding: "0px !important",
                            height: "48px",
                            textAlign: "center !important",
                            borderRadius: "12px !important",
                            borderWidth: "1px",
                            backgroundColor:
                                theme.palette.mode === "light"
                                    ? theme.palette.grey[50]
                                    : theme.palette.background.appFrame,
                            color: theme.palette.text.primary,
                        },
                        "& .MuiFormLabel-root": {
                            marginTop: "4px",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderRadius: "12px !important",
                            borderWidth: "1px",
                        },
                        "legend > span": {
                            opacity: 1,
                            color: theme.palette.primary.main,
                            height: "15px"
                        },
                        "legend": {
                            opacity: 1,
                            color: theme.palette.primary.main,
                            height: "15px",
                            fontSize: "11px"

                        },
                    }}
                >

                    <MenuItem key={"all"} value={"all"}>
                        <Checkbox checked={isAllSensorsSelected()} />
                        <ListItemText primary={translate("ra.action.select_all")} />
                    </MenuItem>

                    {sensorsNames.map((sensorName) => (
                        <MenuItem key={sensorName} value={sensorName}>
                            <Checkbox checked={sensorsToShowNames.indexOf(sensorName) > -1} />
                            <ListItemText primary={translate(`resources.${sensorName}.head`)} />
                        </MenuItem>
                    ))}
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                        <Button sx={{ margin: "5px" }} onClick={() => { handleCloseSelectDisplayedMeasures(); }}>{translate("ra.action.confirm")}</Button>
                    </Box>
                </Select>




                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={searchOption}
                    label={translate("resources.measures.searchOption")}
                    onChange={handleChangeSearchOption}
                    sx={{
                        width: "100%",
                        height: "48px",
                        margin: "16px 0px 0px 0px !important",
                        "& .MuiInputBase-root": {
                            padding: "0px !important",
                            height: "48px",
                            textAlign: "center !important",
                            borderRadius: "12px !important",
                            borderWidth: "1px",
                            backgroundColor:
                                theme.palette.mode === "light"
                                    ? theme.palette.grey[50]
                                    : theme.palette.background.appFrame,
                            color: theme.palette.text.primary,
                        },
                        "& .MuiFormLabel-root": {
                            marginTop: "4px",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderRadius: "12px !important",
                            borderWidth: "1px",
                        },
                        "legend > span": {
                            opacity: 1,
                            color: theme.palette.primary.main,
                            height: "15px"
                        },
                        "legend": {
                            opacity: 1,
                            color: theme.palette.primary.main,
                            height: "15px",
                            fontSize: "11px"

                        },
                    }}
                >
                    <MenuItem value={"last_5"}>{translate("resources.measures.sensor5")}</MenuItem>
                    <MenuItem value={"last_25"}>{translate("resources.measures.sensor25")}</MenuItem>
                    <MenuItem value={"last_50"}>{translate("resources.measures.sensor50")}</MenuItem>
                    <MenuItem value={"last_100"}>{translate("resources.measures.sensor100")}</MenuItem>
                    <MenuItem value={"today"}>{translate("resources.measures.sensorToday")}</MenuItem>
                    <MenuItem value={"yesterday"}>{translate("resources.measures.sensorYesterday")}</MenuItem>
                    <MenuItem value={"custom"}>{translate("resources.measures.customized")}</MenuItem>
                </Select>

                {startDate && endDate &&
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
                        <DateTimePicker
                            label={translate("resources.devices.from")}
                            value={startDate}
                            onChange={(newValue) => { setStartDate(newValue); setSearchOption("custom") }}
                            ampm={false}
                            sx={{
                                width: "100%",
                                height: "48px",
                                margin: "16px 0px 0px 0px !important",
                                "& .MuiInputBase-root": {
                                    padding: "0px !important",
                                    height: "48px",
                                    textAlign: "center !important",
                                    borderRadius: "12px !important",
                                    borderWidth: "1px",
                                    backgroundColor:
                                        theme.palette.mode === "light"
                                            ? theme.palette.grey[50]
                                            : theme.palette.background.appFrame,
                                    color: theme.palette.text.primary,
                                },
                                "& .MuiFormLabel-root": {
                                    marginTop: "4px",
                                },
                                "& .MuiInputBase-input.MuiOutlinedInput-input.MuiInputBase-inputAdornedEnd": {
                                    paddingRight: "4px !important",
                                    paddingLeft: "10px !important",
                                },

                                "& .MuiButtonBase-root.MuiIconButton-root": {
                                    padding: "8px 2px 8px 2px !important",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                    borderRadius: "12px !important",
                                    borderWidth: "1px",
                                    width: "100%",
                                    padding: "0px 0px 0px 0px !important",
                                },

                            }}

                        />
                        <DateTimePicker
                            label={translate("resources.devices.to")}
                            value={endDate}
                            onChange={(newValue) => { setEndDate(newValue); setSearchOption("custom") }}
                            ampm={false}
                            sx={{
                                width: "100%",
                                height: "48px",
                                margin: "16px 0px 0px 0px !important",
                                "& .MuiInputBase-root": {
                                    padding: "0px !important",
                                    height: "48px",
                                    textAlign: "center !important",
                                    borderRadius: "12px !important",
                                    borderWidth: "1px",
                                    backgroundColor:
                                        theme.palette.mode === "light"
                                            ? theme.palette.grey[50]
                                            : theme.palette.background.appFrame,
                                    color: theme.palette.text.primary,
                                },
                                "& .MuiFormLabel-root": {
                                    marginTop: "4px",
                                },
                                "& .MuiInputBase-input.MuiOutlinedInput-input.MuiInputBase-inputAdornedEnd": {
                                    paddingRight: "4px !important",
                                    paddingLeft: "10px !important",
                                },

                                "& .MuiButtonBase-root.MuiIconButton-root": {
                                    padding: "8px 2px 8px 2px !important",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                    borderRadius: "12px !important",
                                    borderWidth: "1px",
                                    width: "100%",
                                    padding: "0px 0px 0px 0px !important",
                                },
                            }}
                        />
                    </LocalizationProvider>
                }



                <Button
                    variant='contained'
                    sx={{ width: "100%", margin: "16px 0px 0px 0px" }}
                    onClick={() => {
                        let filters = {}

                        if (startDate) {
                            filters.start_date = startDate.toISOString()
                        }
                        if (endDate) {
                            filters.end_date = endDate.toISOString()

                        }
                        if (ignorePagination) {
                            filters.ignore_pagination = true
                        } else {
                            filters.ignore_pagination = false
                        }

                        setAllListsFilters(filters)
                        setAllListsPerPage(perPage)
                        setOpen(false)

                    }}>
                    {translate("resources.locations.labels.viewHistory")}
                </Button>


            </DialogContent>


        </Dialog>
    )
}

const FiltersBtn = ({
    label,
    color,
    searchOption,
    setSearchOption,
    startDate,
    setStartDate,
    endDate,
    ignorePagination,
    setEndDate,
    perPage,
    setFilters,
    handleChangeSearchOption,
    sensorsToShowNames,
    handleSensorToShowChange,
    isAllSensorsSelected,
    sensorsNames,
    setAllListsFilters,
    setAllListsPerPage
}) => {
    const [open, setOpen] = React.useState(false);

    return (
        <div>
            <Button sx={{ color: color }}
                onClick={(e) => { e.preventDefault(); setOpen(!open) }}
            >
                <FiltersIcon color={color} />&nbsp;{label}
            </Button>
            <FiltersDialog
                open={open}
                setOpen={setOpen}
                searchOption={searchOption}
                setSearchOption={setSearchOption}
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                ignorePagination={ignorePagination}
                setEndDate={setEndDate}
                perPage={perPage}
                setFilters={setFilters}
                handleChangeSearchOption={handleChangeSearchOption}
                sensorsToShowNames={sensorsToShowNames}
                handleSensorToShowChange={handleSensorToShowChange}
                isAllSensorsSelected={isAllSensorsSelected}
                sensorsNames={sensorsNames}
                setAllListsFilters={setAllListsFilters}
                setAllListsPerPage={setAllListsPerPage}

            />
        </div>



    )
}

const MobileActions = ({
    searchOption,
    setSearchOption,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    ignorePagination,
    perPage,
    handleChangeSearchOption,
    sensorsToShowNames,
    handleSensorToShowChange,
    isAllSensorsSelected,
    sensorsNames,
    setAllListsFilters,
    setAllListsPerPage
}) => {
    const theme = useTheme();
    const translate = useTranslate()

    return (


        <Box sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            borderRadius: "12px",
            alignItems: "center",
            padding: "0px",
            margin: "0px 0px 16px 0px",
            width: "100%",
            height: "48px",
            backgroundColor: theme.palette.background.paper

        }}>

            <FiltersBtn
                color={theme.palette.text.secondary}
                label={translate("resources.common.filter")}
                searchOption={searchOption}
                setSearchOption={setSearchOption}
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
                ignorePagination={ignorePagination}
                perPage={perPage}
                handleChangeSearchOption={handleChangeSearchOption}
                sensorsToShowNames={sensorsToShowNames}
                handleSensorToShowChange={handleSensorToShowChange}
                isAllSensorsSelected={isAllSensorsSelected}
                sensorsNames={sensorsNames}
                setAllListsFilters={setAllListsFilters}
                setAllListsPerPage={setAllListsPerPage}

            />

        </Box>


    )
}




const startDateFromSearchOption = (searchOption) => {
    let date = new Date()
    date.setHours(0)
    date.setMinutes(0)
    date.setSeconds(0)
    date.setMilliseconds(0)
    switch (searchOption) {
        case "today":
            break;
        case "custom":
            break;
        case "yesterday":
            date.setDate(date.getDate() - 1)
            break;
        default:
            return null
    }
    return dayjs(date.toISOString())
}


const endDateFromSearchOption = (searchOption) => {
    let date = new Date()
    date.setHours(23)
    date.setMinutes(59)
    date.setSeconds(59)
    date.setMilliseconds(999)
    switch (searchOption) {
        case "today":
            break;
        case "custom":
            break;
        case "yesterday":
            date.setDate(date.getDate() - 1)
            break;
        default:
            return null
    }
    return dayjs(date.toISOString())
}


const perPageFromSearchOption = (searchOption) => {
    switch (searchOption) {
        case "last_5":
            return 5
        case "last_25":
            return 25
        case "last_50":
            return 50
        case "last_100":
            return 100
        default:
            return 500
    }
}


const ignorePaginationFromSearchOption = (searchOption) => {
    switch (searchOption) {
        case "last_5":
            return true
        case "last_25":
            return true
        case "last_50":
            return true
        case "last_100":
            return true
        default:
            return false
    }
}


const SensorsHistoryActions = (props) => {
    const { sensorsToShowNames, setSensorsToShowNames, sensorsNames, setAllListsFilters, setAllListsPerPage, recordId, isMobile } = props
    const theme = useTheme();
    const translate = useTranslate();
    const [locale, setLocale] = useLocaleState();
    const styles = customStyles({ theme });
    const [searchOption, setSearchOption] = useState("last_5");
    const [ignorePagination, setIgnorePagination] = useState(ignorePaginationFromSearchOption("last_5"));
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [perPage, setPerPage] = useState(perPageFromSearchOption("last_5"));
    const [openSelectDisplayedMeasures, setOpenSelectDisplayedMeasures] = useState(false);



    const handleCloseSelectDisplayedMeasures = () => {
        setOpenSelectDisplayedMeasures(false);
    };

    const handleOpenSelectDisplayedMeasures = () => {
        setOpenSelectDisplayedMeasures(true);
    };



    const isAllSensorsSelected = () => {
        if (sensorsNames.every(element => sensorsToShowNames.includes(element))) return true;

    }
    const handleSensorToShowChange = (event) => {
        const {
            target: { value },
        } = event;
        if (value[value.length - 1] === "all") {
            setSensorsToShowNames(isAllSensorsSelected() ? [] : sensorsNames);
            return;
        }
        setSensorsToShowNames(
            typeof value === 'string' ? value.split(',') : value,
        );
    };


    const handleChangeSearchOption = (event) => {
        const { value } = event.target
        setSearchOption(value)
        setStartDate(startDateFromSearchOption(value))
        setEndDate(endDateFromSearchOption(value))
        setPerPage(perPageFromSearchOption(value))
        setIgnorePagination(ignorePaginationFromSearchOption(value))
    }



    if (isMobile) return (<MobileActions
        searchOption={searchOption}
        setSearchOption={setSearchOption}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        perPage={perPage}
        ignorePagination={ignorePagination}
        handleChangeSearchOption={handleChangeSearchOption}
        sensorsToShowNames={sensorsToShowNames}
        handleSensorToShowChange={handleSensorToShowChange}
        isAllSensorsSelected={isAllSensorsSelected}
        sensorsNames={sensorsNames}
        setAllListsFilters={setAllListsFilters}
        setAllListsPerPage={setAllListsPerPage}

    />)

    return (

        <Box
            sx={styles.container}
        >

            <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                label={translate("resources.measures.displayedMeasures")}
                multiple
                value={sensorsToShowNames}
                onChange={handleSensorToShowChange}
                open={openSelectDisplayedMeasures}
                onClose={handleCloseSelectDisplayedMeasures}
                onOpen={handleOpenSelectDisplayedMeasures}
                renderValue={() => translate("resources.measures.displayedMeasures")}
                MenuProps={{
                    PaperProps: {
                        style: {
                            maxHeight: "220px",
                        },
                    },
                }}
                sx={{
                    width: "175px",
                    height: "48px",
                    margin: "0px 10px 0px 0px !important",
                    "& .MuiInputBase-root": {
                        padding: "0px !important",
                        height: "48px",
                        textAlign: "center !important",
                        borderRadius: "12px !important",
                        borderWidth: "1px",
                        backgroundColor:
                            theme.palette.mode === "light"
                                ? theme.palette.grey[50]
                                : theme.palette.background.appFrame,
                        color: theme.palette.text.primary,
                    },
                    "& .MuiFormLabel-root": {
                        marginTop: "4px",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderRadius: "12px !important",
                        borderWidth: "1px",
                    },
                    "legend > span": {
                        opacity: 1,
                        color: theme.palette.primary.main,
                        height: "15px"
                    },
                    "legend": {
                        opacity: 1,
                        color: theme.palette.primary.main,
                        height: "15px",
                        fontSize: "11px"

                    },
                }}
            >

                <MenuItem key={"all"} value={"all"}>
                    <Checkbox checked={isAllSensorsSelected()} />
                    <ListItemText primary={translate("ra.action.select_all")} />
                </MenuItem>

                {sensorsNames.map((sensorName) => (
                    <MenuItem key={sensorName} value={sensorName}>
                        <Checkbox checked={sensorsToShowNames.indexOf(sensorName) > -1} />
                        <ListItemText primary={translate(`resources.${sensorName}.head`)} />
                    </MenuItem>
                ))}

                <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Button sx={{ margin: "5px" }} onClick={() => { handleCloseSelectDisplayedMeasures(); }}>{translate("ra.action.confirm")}</Button>
                </Box>

            </Select>




            <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={searchOption}
                label={translate("resources.measures.searchOption")}
                onChange={handleChangeSearchOption}
                sx={{
                    width: "150px",
                    height: "48px",
                    margin: "0px 10px 0px 0px !important",
                    "& .MuiInputBase-root": {
                        padding: "0px !important",
                        height: "48px",
                        textAlign: "center !important",
                        borderRadius: "12px !important",
                        borderWidth: "1px",
                        backgroundColor:
                            theme.palette.mode === "light"
                                ? theme.palette.grey[50]
                                : theme.palette.background.appFrame,
                        color: theme.palette.text.primary,
                    },
                    "& .MuiFormLabel-root": {
                        marginTop: "4px",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderRadius: "12px !important",
                        borderWidth: "1px",
                    },
                    "legend > span": {
                        opacity: 1,
                        color: theme.palette.primary.main,
                        height: "15px"
                    },
                    "legend": {
                        opacity: 1,
                        color: theme.palette.primary.main,
                        height: "15px",
                        fontSize: "11px"

                    },
                }}
            >
                <MenuItem value={"last_5"}>{translate("resources.measures.sensor5")}</MenuItem>
                <MenuItem value={"last_25"}>{translate("resources.measures.sensor25")}</MenuItem>
                <MenuItem value={"last_50"}>{translate("resources.measures.sensor50")}</MenuItem>
                <MenuItem value={"last_100"}>{translate("resources.measures.sensor100")}</MenuItem>
                <MenuItem value={"today"}>{translate("resources.measures.sensorToday")}</MenuItem>
                <MenuItem value={"yesterday"}>{translate("resources.measures.sensorYesterday")}</MenuItem>
                <MenuItem value={"custom"}>{translate("resources.measures.customized")}</MenuItem>
            </Select>

            {startDate && endDate &&
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
                    <DateTimePicker
                        label={translate("resources.devices.from")}
                        value={startDate}
                        onChange={(newValue) => { setStartDate(newValue); setSearchOption("custom") }}
                        ampm={false}
                        sx={{
                            width: "180px",
                            height: "48px",
                            margin: "0px 30px 0px 0px !important",
                            "& .MuiInputBase-root": {
                                padding: "0px !important",
                                height: "48px",
                                textAlign: "center !important",
                                borderRadius: "12px !important",
                                borderWidth: "1px",
                                backgroundColor:
                                    theme.palette.mode === "light"
                                        ? theme.palette.grey[50]
                                        : theme.palette.background.appFrame,
                                color: theme.palette.text.primary,
                            },
                            "& .MuiFormLabel-root": {
                                marginTop: "4px",
                            },
                            "& .MuiInputBase-input.MuiOutlinedInput-input.MuiInputBase-inputAdornedEnd": {
                                paddingRight: "4px !important",
                                paddingLeft: "10px !important",
                            },

                            "& .MuiButtonBase-root.MuiIconButton-root": {
                                padding: "8px 2px 8px 2px !important",
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                                borderRadius: "12px !important",
                                borderWidth: "1px",
                                width: "200px",
                                padding: "0px 30px 0px 8px !important",
                            },

                        }}

                    />
                    <DateTimePicker
                        label={translate("resources.devices.to")}
                        value={endDate}
                        onChange={(newValue) => { setEndDate(newValue); setSearchOption("custom") }}
                        ampm={false}
                        sx={{
                            width: "180px",
                            height: "48px",
                            margin: "0px 30px 0px 0px !important",
                            "& .MuiInputBase-root": {
                                padding: "0px !important",
                                height: "48px",
                                textAlign: "center !important",
                                borderRadius: "12px !important",
                                borderWidth: "1px",
                                backgroundColor:
                                    theme.palette.mode === "light"
                                        ? theme.palette.grey[50]
                                        : theme.palette.background.appFrame,
                                color: theme.palette.text.primary,
                            },
                            "& .MuiFormLabel-root": {
                                marginTop: "4px",
                            },
                            "& .MuiInputBase-input.MuiOutlinedInput-input.MuiInputBase-inputAdornedEnd": {
                                paddingRight: "4px !important",
                                paddingLeft: "10px !important",
                            },

                            "& .MuiButtonBase-root.MuiIconButton-root": {
                                padding: "8px 2px 8px 2px !important",
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                                borderRadius: "12px !important",
                                borderWidth: "1px",
                                width: "200px",
                                padding: "0px 30px 0px 8px !important",
                            },
                        }}
                    />
                </LocalizationProvider>
            }



            <Button
                variant='contained'
                sx={{ my: 1 }}
                onClick={() => {
                    let filters = {}

                    if (startDate) {
                        filters.start_date = startDate.toISOString()
                    }
                    if (endDate) {
                        filters.end_date = endDate.toISOString()
                    }

                    if (ignorePagination) {
                        filters.ignore_pagination = true
                    } else {
                        filters.ignore_pagination = false
                    }

                    setAllListsFilters(filters)
                    setAllListsPerPage(perPage)

                }}>
                {translate("resources.locations.labels.viewHistory")}
            </Button>

            <Box sx={{
                display: 'flex',
                flex: 1
            }} />
            <ExportDataButton selectedIds={recordId} />
        </Box>



    );
}





export default SensorsHistoryActions;





